// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2307":"e93f1fe0","4280":"e93f1fe0","5404":"e93f1fe0","6174":"e93f1fe0","6895":"e93f1fe0"}[chunkId] + ".chunk.css";
};